module.exports = __webpack_public_path__ + "static/icon-loan.bd475029.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-loan.png
// module id = 983
// module chunks = 2